import BaseStore from 'stores/BaseStore';

class IntegrationStore extends BaseStore {
  constructor() {
    super('integrations', 'integration', { site_model: true })
  }
}

export default new IntegrationStore()
